/**
 * Cdropdown Component
 * Reusable dropdown menu with trigger-anchored and caret-anchored modes.
 */
"use client";
import type { ReactElement } from "react";
import { ButtonPreset } from "@/constants/componentPresets";
import { Cbutton } from "../Cbutton";
import { DropdownSurface } from "./DropdownSurface";
import type { CdropdownProps } from "./Cdropdown.types";
import { useCdropdownController } from "./useCdropdownController";
export type { CdropdownAlign, CdropdownMode, CdropdownOpenDirection, CdropdownOption, CdropdownOptionRenderState, CdropdownProps, } from "./Cdropdown.types";
export function Cdropdown(props: CdropdownProps): ReactElement {
    const { trigger, triggerRef, triggerStyle, onTriggerClick, shouldRenderTrigger, shouldRenderSurface, surfaceProps, } = useCdropdownController(props);
    return (
    <>
      {shouldRenderTrigger && (<Cbutton
          rootRef={triggerRef}
          preset={ButtonPreset.Ghost}
          disableHoverEffects
          padding={0}
          disabled={props.triggerDisabled}
          onClick={onTriggerClick}
          style={triggerStyle}
          containerStyle={{ width: "100%" }}
        >
          {trigger}
        </Cbutton>)}

      {shouldRenderSurface && <DropdownSurface {...surfaceProps} dataElScope={props.dataElScope}/>}
    </>
    );
}
